import type {
  GraphCacheOptimisticUpdaters,
  GraphCacheResolvers,
  GraphCacheUpdaters
} from "gql/api";
import { retrieveAccessTokenFromLocalStorage } from "@/utils/utils-dependent";
export interface ModelsResolver {
  queries?: GraphCacheResolvers;
  optimistic?: GraphCacheOptimisticUpdaters;
  updates?: GraphCacheUpdaters["Mutation"];
  subscriptions?: GraphCacheUpdaters["Subscription"];
}

export const revisionDefaultFields = (object: any) => {
  // If offline, object won't have an author_id once 'saved'. Need to get from token in
  // localStorage
  const authorId = object.author_id
    ? object.author_id
    : retrieveAccessTokenFromLocalStorage()?.claims.uid;

  const defaults = {
    id: object.journal_id || null,
    parent_id: object.parent_id || null,
    winning_revision_parent_id: object.winning_revision_parent_id || null,
    winning_revision_id: object.id || null,
    winning_revision_author_id: authorId || null,
    winning_revision_created_at: object.winning_revision_created_at || null,
    winning_revision_updated_at: object.winning_revision_updated_at || null,
    winning_revision_deleted_at: object.winning_revision_deleted_at || null,
    journal_author_id: authorId || null,
    journal_deleted_at: object.deleted_at || null,
    journal_updated_at: object.updated_at || new Date(),
    journal_created_at: object.created_at || new Date()
  };
  return defaults;
};
